import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";
import { Avatar, Stack, Typography } from "@mui/material";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { appUrl } from "Utils/UrlUtils";
import PaypointImage from "Assets/Images/Images/moone-paypoint.svg";

const RESOURCES = Resources.Paypoint;

type Props = {
  owner: string;
  logoUrl?: string;
};

export const LoggedUserContent = ({ owner, logoUrl }: Props) => {
  const { t } = useResource();

  return (
    <>
      <PrimaryPaper sx={{ maxWidth: 600 }}>
        <Stack alignItems="center" gap={3} py={1}>
          <Typography variant="h3" textAlign="center">
            {owner}
          </Typography>
          {logoUrl ? (
            <Avatar
              src={logoUrl}
              variant="rounded"
              sx={{ width: 200, height: 200 }}
            />
          ) : (
            <img src={PaypointImage} width="70%" alt="Moone paypoint" />
          )}
          <Typography variant="h6" textAlign="center">
            {t(RESOURCES.IdlePaypointInfo)}
          </Typography>
        </Stack>
      </PrimaryPaper>
      <ButtonLink
        link={appUrl("dashboard")}
        text={t(RESOURCES.BackToDashboard)}
      />
    </>
  );
};
